import { render } from "./CAlert.vue?vue&type=template&id=05e875d9&scoped=true"
import script from "./CAlert.vue?vue&type=script&lang=js"
export * from "./CAlert.vue?vue&type=script&lang=js"

import "./CAlert.vue?vue&type=style&index=0&id=05e875d9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05e875d9"]])

export default __exports__